import React from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';
import ImageSlider from './carrousselactivites';


const Activites = (props) => {

  return (
    <div>  
            <Header />

    <div id="activites">

      <div className="container">
<br></br>
<br></br>
        <div className="section-title">
          <h2>Mes activités</h2>
          <br></br>
              <br></br>
              <br></br>
             
   <ImageSlider />
        </div>
        <br></br>
        <br></br>
        <div className="activites-list">
        <h4>Je vous propose également :</h4>
       <br></br>
        <ul>
        <p> <li>de la danse afro</li></p>
            <p> <li> du nordique fit (renforcement musculaire avec bâtons)</li></p>
            <p> <li> du fit stick (danse avec bâton)</li></p>
            <p><li>une formation efformit (sport sur ordonnance) pour maladie chronique</li></p>
            </ul>

          <br></br>
          <br></br>
<h4> Les tarifs :</h4>
<br></br>
<ul>
  <p><li>Coaching privé : 40€ l'heure</li></p>
  <p><li>Forfait 10 séances : 110€ valable 6 mois</li></p>
  <p><li>Tarifs groupe, mixte ou entre femmes : 10€ la séance</li></p>
</ul>
<br></br>
<p>Horaire de 8 heures à 22 heures, 7 jours sur 7 adaptable selon disponibilité.</p>
</div>
      </div>
      </div>
  
      < Footer />

    </div>

  );
};
export default Activites;